import $ from 'jquery';
import Util from 'bootstrap/js/src/util';

class ClassName {

  constructor ( element ) {
    this._element = element;
  }

  add ( relatedTarget ) {
    this.toggle( relatedTarget, 'addClass' );
  }

  remove ( relatedTarget ) {
    this.toggle( relatedTarget, 'removeClass' );
  }

  toggle ( relatedTarget, _method ) {
    const $element = $( this._element );
    const className = $element.data( 'class' );
    let method = _method || 'toggleClass';
    if ( className ) {
      $element.trigger( $.Event( 'toggl', { 'relatedTarget': relatedTarget } ) )
      $element[ method ]( className )
      $element.trigger( $.Event( 'toggled', { 'relatedTarget': relatedTarget } ) )
    }
  }

  static _handleToggle( varInstance ) {
    return function ( event ) {
      if ( event ) {
        event.preventDefault();
      }
      varInstance.toggle( this );
    }
  }

  static _jQueryInterface( method, relatedTarget ) {
    return this.each( function () {
      let data = $( this ).data( '_class-name' );

      if ( ! data ) {
        data = new ClassName( this );
        $( this ).data( '_class-name', data );
      }

      if ( typeof method === 'string' ) {
        if ( typeof data[method] === 'undefined' ) {
          throw new TypeError( `No method named "${method}"` );
        }
        data[ method ]( relatedTarget );
      }
    } );
  }
}

/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */

$(document).on( 'click', '[data-toggle="class-name"]', function ( e ) {
  // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
  if ( e.currentTarget.tagName === 'A' ) {
    e.preventDefault();
  }

  const $trigger = $( this );
  const selector = Util.getSelectorFromElement( this );
  const selectors = [].slice.call( document.querySelectorAll( selector ) );

  $( selectors ).each( function () {
    ClassName._jQueryInterface.call( $( this ), 'toggle', $trigger[0] );
  } );
} );

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn.className             = ClassName._jQueryInterface;
$.fn.className.Constructor = ClassName;

export default ClassName;